export const translation = {
  "nav.home": "Hjem",
  "nav.spreadsheet": "Regneark",
  "nav.guides": "Guider",
  "nav.shipping": "Forsendelse",
  "nav.qc": "Kvalitetskontrol",
  "nav.reviews": "Anmeldelser",
  "nav.comparisons": "Sammenligninger",
  "nav.safety": "Sikkerhed",
  "nav.categories": "Kategorier",
  "nav.language": "Sprog",
  "nav.about": "Om Os",
  "nav.contact": "Kontakt",
  "nav.buyingGuide": "Købsguide",
  "nav.faq": "FAQ",
  "hero.title": "AllChinaBuy Spreadsheet — Din Komplette Guide til Produkter, Sælgere, Kvalitetskontrol & Forsendelse",
  "hero.subtitle": "Find Bedre Produkter med AllChinaBuy Spreadsheet",
  "hero.description": "AllChinaBuy Spreadsheet er et praktisk udgangspunkt for at opdage produkter, undersøge sælgere og forstå købsprocessen. Udforsk produktlister, sælgerinformation, kvalitetskontrolressourcer, forsendelsesguider og nyttige tips i en organiseret ressource.",
  "hero.cta.primary": "Udforsk AllChinaBuy Spreadsheet",
  "hero.cta.secondary": "Gennemse Den Komplette Guide",
  "hero.trust": "Uafhængig Ressource • Opdaterede Guider • Praktiske Købsinformationer",
  "cta.mainWebsite": "AllChinaBuy Spreadsheet",
  "cta.buyNow": "Køb Nu",
  "cta.visitMain": "Besøg Hovedsiden",
  "section.whatIs.title": "Hvad er AllChinaBuy Spreadsheet?",
  "section.whatIs.description": "Leder du efter en nemmere måde at undersøge produkter og sælgere på? AllChinaBuy Spreadsheet samler nyttig produktinformation i en søgbar ressource. I stedet for at hoppe mellem spredte links, brug regnearket til at opdage kategorier, sammenligne muligheder og fortsætte din forskning med detaljerede guider.",
  "section.whatIs.cta": "Udforsk Regnearkressourcer",
  "section.everything.title": "Alt Du Behøver at Vide Om AllChinaBuy",
  "card.spreadsheet.title": "AllChinaBuy Spreadsheet",
  "card.spreadsheet.desc": "Opdag produkter, kategorier og sælgerressourcer.",
  "card.review.title": "AllChinaBuy Anmeldelse",
  "card.review.desc": "Forstå platformen, funktionerne, købsprocessen og vigtige overvejelser.",
  "card.shipping.title": "AllChinaBuy Forsendelsesomkostninger",
  "card.shipping.desc": "Lær om forsendelsesmetoder, prisfaktorer, leveringstider og måder at reducere unødvendige omkostninger på.",
  "card.warehouse.title": "AllChinaBuy Lager",
  "card.warehouse.desc": "Forstå lageropbevaring, kvalitetskontrolfotos, forberedelse af pakker og forsendelsesworkflow.",
  "card.coupon.title": "AllChinaBuy Kupon",
  "card.coupon.desc": "Find aktuelle kuponinformationer og forstå hvordan rabatter kan fungere.",
  "card.discount.title": "AllChinaBuy Rabatkode",
  "card.discount.desc": "Udforsk tilgængelige rabatinformationer og verificer vilkår før brug af enhver kode.",
  "card.legit.title": "AllChinaBuy Legitim",
  "card.legit.desc": "Lær hvordan du vurderer platformens legitimiteit, sælgerpålidelighed og almindelige købsrisici.",
  "card.qc.title": "AllChinaBuy Kvalitetskontrol",
  "card.qc.desc": "Forstå kvalitetskontrolfotos, produkttjek og hvad du skal gennemgå før forsendelse.",
  "card.shippingCost.title": "AllChinaBuy Forsendelsesomkostninger",
  "card.shippingCost.desc": "Forstå forsendelsestakster, metoder, vægtfaktorer og hvordan du estimerer omkostninger.",
  "card.discountCode.title": "AllChinaBuy Rabatkode",
  "card.discountCode.desc": "Find aktuelle rabatkoder og lær hvordan du verificerer tilbud før brug.",
  "card.sellers.title": "AllChinaBuy Sælgere",
  "card.sellers.desc": "Lær hvordan du identificerer betroede sælgere og undgår upålidelige leverandører.",
  "card.comparison.title": "AllChinaBuy Sammenligning",
  "card.comparison.desc": "Sammenlign AllChinaBuy med andre agenter på tværs af nøgledimensioner.",
  "card.buyingGuide.title": "AllChinaBuy Købsguide",
  "card.buyingGuide.desc": "En trin-for-trin guide fra produktsøgning til endelig levering.",
  "card.beginner.title": "AllChinaBuy for Begyndere",
  "card.beginner.desc": "Alt hvad førstegangskøbere skal vide før deres første ordre.",
  "card.payment.title": "AllChinaBuy Betalingsguide",
  "card.payment.desc": "Forstå betalingsmetoder, faser og bedste praksis for sikkerhed.",
  "card.refund.title": "AllChinaBuy Refunderingsguide",
  "card.refund.desc": "Lær hvordan returneringer, tvister og refunderinger fungerer på platformen.",
  "card.parcel.title": "AllChinaBuy Pakkeguide",
  "card.parcel.desc": "Emballage-, konsoliderings- og beskyttelsestips til international forsendelse.",
  "card.safetyGuide.title": "AllChinaBuy Sikkerhedsguide",
  "card.safetyGuide.desc": "Undgå svindel, beskyt din konto og køb med tillid.",
  "section.howTo.title": "Sådan Bruger Du AllChinaBuy Spreadsheet",
  "step1": "Vælg en produktkategori.",
  "step2": "Åbn den relevante regnearkressource.",
  "step3": "Sammenlign produkter og sælgere.",
  "step4": "Gennemgå kvalitetskontrolinformation og sælgerdetaljer.",
  "step5": "Tjek forsendelsesinformation før bestilling.",
  "step6": "Fortsæt til hovedsiden når du er klar.",
  "section.categories.title": "Populære AllChinaBuy Spreadsheet Kategorier",
  "category.shoes": "Sko",
  "category.hoodies": "Hættetrøjer/Sweaters",
  "category.tshirts": "T-Shirts",
  "category.jackets": "Jakker",
  "category.pants": "Bukser/Shorts",
  "category.headwear": "Hovedbeklædning",
  "category.sets": "Sæt",
  "category.underwear": "Undertøj/Underbukser",
  "category.jersey": "Trøjer",
  "category.accessories": "Tilbehør",
  "category.bags": "Tasker",
  "category.belts": "Bælter",
  "category.perfumes": "Parfumer",
  "category.other": "Andre Ting",
  "section.compare.title": "Sammenlign Før Du Køber",
  "section.shipping.title": "AllChinaBuy Forsendelsesguide",
  "section.shipping.description": "Forsendelsesomkostninger kan variere afhængigt af pakkens vægt, destination, forsendelsesmetode, dimensioner og aktuelle transportørbetingelser. Brug vores forsendelsesressourcer til at forstå de vigtigste omkostningsfaktorer før du forbereder en pakke.",
  "section.shipping.cta": "Se AllChinaBuy Forsendelsesomkostningsguide",
  "section.safety.title": "AllChinaBuy Sikkerhedsguide",
  "section.safety.description": "Køb gennem internationale markedspladser kræver omhyggelig research. Lær hvordan du verificerer sælgere, gennemgår kvalitetskontrolinformation, beskytter kontodetaljer, forstår forsendelsesrisici og genkender mistænkelige tilbud.",
  "section.safety.cta": "Læs AllChinaBuy Sikkerhedsguide",
  "section.guides.title": "Seneste AllChinaBuy Guider",
  "section.faq.title": "Ofte Stillede Spørgsmål",
  "faq.q1": "Hvad er AllChinaBuy Spreadsheet?",
  "faq.a1": "AllChinaBuy Spreadsheet er en organiseret ressource, der samler produktinformation, sælgerdetaljer og købsguider for at hjælpe dig med at undersøge produkter mere effektivt.",
  "faq.q2": "Hvordan fungerer AllChinaBuy Spreadsheet?",
  "faq.a2": "Regnearket kategoriserer produkter efter type, så du kan gennemse kategorier, sammenligne muligheder og finde relevante sælgere med detaljeret information.",
  "faq.q3": "Er AllChinaBuy legitim?",
  "faq.a3": "AllChinaBuy er en købsagentplatform. Som ethvert internationalt marked er det vigtigt at undersøge sælgere, gennemgå kvalitetskontrolfotos og forstå processen før køb.",
  "faq.q4": "Er AllChinaBuy sikker?",
  "faq.a4": "Sikkerhed afhænger af at følge bedste praksis: verificer sælgere, gennemgå kvalitetskontrolfotos, brug sikre betalingsmetoder og forstå forsendelses- og refunderingspolitikker.",
  "faq.q5": "Hvor meget koster AllChinaBuy forsendelse?",
  "faq.a5": "Forsendelsesomkostninger varierer baseret på pakkens vægt, dimensioner, destination, forsendelsesmetode og aktuelle transportørtakster. Brug vores forsendelsesguide for detaljeret information.",
  "faq.q6": "Hvor er AllChinaBuy lageret?",
  "faq.a6": "AllChinaBuy driver lagre i Kina til modtagelse, inspektion og videresendelse af pakker til internationale købere.",
  "faq.q7": "Hvordan fungerer AllChinaBuy kuponer?",
  "faq.a7": "Kuponer og rabatkoder kan være tilgængelige for nye brugere, sæsonbestemte kampagner eller specifikke produktkategorier. Verificer altid vilkår og udløbsdatoer.",
  "faq.q8": "Hvor kan jeg finde en AllChinaBuy rabatkode?",
  "faq.a8": "Rabatkoder kan være tilgængelige gennem promotionelle e-mails, affiliatpartnere eller sæsonbestemte kampagner. Tjek vores kuponguide for aktuel information.",
  "faq.q9": "Hvordan tjekker jeg kvalitetskontrolfotos?",
  "faq.a9": "Kvalitetskontrolfotos tages på lageret før forsendelse. Du kan gennemgå dem på din konto for at verificere produktets tilstand, farve og detaljer.",
  "faq.q10": "Hvordan kan jeg finde produkter gennem AllChinaBuy?",
  "faq.a10": "Brug regnearket til at gennemse kategorier, eller søg direkte efter produktnavn, kategori eller sælger for at finde det du leder efter.",
  "finalCta.title": "Klar til at Udforske AllChinaBuy Spreadsheet?",
  "finalCta.description": "Start med regnearket, sammenlign dine muligheder, lær hvordan købsprocessen fungerer, og brug vores guider til at træffe mere informerede beslutninger.",
  "finalCta.button": "Udforsk AllChinaBuy Spreadsheet",
  "footer.spreadsheet": "AllChinaBuy Spreadsheet",
  "footer.guides": "Guider",
  "footer.reviews": "Anmeldelser",
  "footer.shipping": "Forsendelse",
  "footer.qc": "Kvalitetskontrol",
  "footer.safety": "Sikkerhed",
  "footer.about": "Om Os",
  "footer.contact": "Kontakt",
  "footer.privacy": "Privatlivspolitik",
  "footer.terms": "Vilkår og Betingelser",
  "footer.disclaimer": "Ansvarsfraskrivelse",
  "footer.disclaimerText": "Dette website er en uafhængig informationsressource og er ikke tilknyttet AllChinaBuy medmindre det udtrykkeligt er angivet.",
  "footer.mainCta": "Besøg Hovedsiden",
  "footer.copyright": "AllChinaBuy Spreadsheet. Alle rettigheder forbeholdes.",
  "breadcrumb.home": "Hjem",
  "article.readMore": "Læs Mere",
  "article.published": "Udgivet",
  "article.updated": "Opdateret",
  "article.author": "Redaktionelt Team",
  "article.minRead": "min læsning",
  "seo.title.home": "AllChinaBuy Spreadsheet – Produkter, Sælgere, Kvalitetskontrol & Forsendelsesguide",
  "seo.description.home": "Udforsk AllChinaBuy Spreadsheet med produktlister, betroede sælgere, kvalitetskontroltips, forsendelsesinformation, lagerguider, anmeldelser og praktiske købsressourcer.",
  "meta.keywords": "AllChinaBuy, AllChinaBuy Spreadsheet, AllChinaBuy anmeldelse, AllChinaBuy forsendelse, AllChinaBuy kupon, AllChinaBuy rabatkode, AllChinaBuy lager, AllChinaBuy kvalitetskontrol, AllChinaBuy legitim, AllChinaBuy guide",
  "compare.feature": "Funktion",
  "compare.allchinabuy": "AllChinaBuy",
  "compare.superbuy": "Superbuy",
  "compare.cssbuy": "CSSBuy",
  "compare.sugargoo": "Sugargoo",
  "compare.productDiscovery": "Produktopdagelse",
  "compare.spreadsheet": "Regnearkressourcer",
  "compare.qcProcess": "Kvalitetskontrolproces",
  "compare.warehouse": "Lager",
  "compare.shipping": "Forsendelse",
  "compare.payment": "Betaling",
  "compare.beginnerFriendly": "Begyndervenlig",
  "compare.support": "Support",
  "compare.research": "Forskningserfaring",
  "learnMore": "Læs Mere",
  "readGuide": "Læs Guiden",
  "backToHome": "← Tilbage til Hjem",
  "safetyCenter.title": "Sikkerhedscenter",
  "safetyCenter.description": "Vigtige sikkerhedsinformationer for køb gennem internationale markedspladser.",
  "disclaimer.title": "Ansvarsfraskrivelse",
  "disclaimer.text": "Dette website er en uafhængig informationsressource. Alle oplysninger er kun til undervisningsformål. Vi er ikke tilknyttet AllChinaBuy eller nogen købsagentplatform. Foretag altid din egen research før du foretager køb.",
  "productShowcase.title": "Gennemse Udvalgte Produkter",
  "productShowcase.description": "Udforsk vores kuraterede udvalg på tværs af alle kategorier. Klik på ethvert produkt for at besøge hovedbutikken og gennemføre dit køb.",
  "productShowcase.ctaTitle": "Vil du se mere?",
  "productShowcase.ctaDesc": "Besøg den fulde butik for tusindvis af flere produkter i alle kategorier.",
  "productShowcase.ctaButton": "Besøg Den Fuldendte Butik",
  "productShowcase.buyNow": "Køb Nu"
};